import { render, staticRenderFns } from "./Paintable-Navigation.vue?vue&type=template&id=4ba6af28&scoped=true&"
import script from "./Paintable-Navigation.vue?vue&type=script&lang=js&"
export * from "./Paintable-Navigation.vue?vue&type=script&lang=js&"
import style0 from "./Paintable-Navigation.vue?vue&type=style&index=0&id=4ba6af28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba6af28",
  null
  
)

export default component.exports